<template>
  <div>
    <!-- 화면 타이틀 -->
    <v-row class="title-wrap fixed">
      <v-col cols="12" class="icon-title word-type">
        <icon-application-cancel :width="24" :height="24" />
        {{ $t('취소 신청') }}
      </v-col>
      <v-col cols="12" class="pt-0 pb-3 px-6 title-desc">
        <v-chip label class="chip-desc" color="#E8F9ED">
          <span> {{ $t('취소할 신청서를 선택해 주세요') }}</span>
        </v-chip>
      </v-col>
    </v-row>

    <!-- 취소 신청서 리스트 -->
    <appl-doc-list
      class="overflow-y-auto"
      :style="scrollViewStyle"
      :searchReqGubun="'CANCEL'"
      :searchApplCd="searchApplCd"
    />
  </div>
</template>

<script>
/* (근태|보상휴가)취소신청 메뉴  */
import ApplDocList from '@/components/allDoc/ApplDocList.vue';
import IconApplicationCancel from '@/assets/customIcon/IconApplicationCancel.vue';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    searchApplCd: '',
  }),
  computed: {
    ...mapGetters('ELA', ['GET_SEARCH_APPL_CD']),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - (this.$store.getters.HEIGHT_TITLE + 36) // chip 높이 36
      }px`;
    },
  },
  created() {
    // 모달 활성화시 store의 신청서코드가 변경되므로 사용
    this.searchApplCd = this.GET_SEARCH_APPL_CD;
  },
  components: {
    ApplDocList,
    IconApplicationCancel,
  },
};
</script>

<style>
.title-desc {
  padding-bottom: 30px;
}
</style>
